export default class dadosCliente {

    constructor(_id = null, name = "", tax_id = "", document = "") {
        this._id = _id;
        this.name = name;
        this.tax_id = tax_id;
        this.document = document;
    }
    
}